import React from 'react';
import COLORS from 'shared/constants/colors';
import makeStyles from '@mui/styles/makeStyles';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { columns } from 'pages/my-stores/stores/columns';

const useStyles = makeStyles({
  th: {
    color: COLORS.BODY_TEXT,
    fontSize: '13px',
  },
});

const StoresTableHead = () => {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            className={classes.th}
            key={`storeHead${column.id}`}
            align={column.align}
            style={{ minWidth: column.minWidth }}>
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default StoresTableHead;
